export default {
    send: 'Always send',
    dontSend: "Don't send if closed",
    nextOpen: 'Execute at next open business hour',
    weekdays: 'Only on chosen days',
};
